import React from 'react';

const TiktokIcon = ({ className, size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M16.83 5a4.13 4.13 0 0 1-2.83-1.17A4.13 4.13 0 0 1 13 1h-2v12a3 3 0 1 1-3-3" />
    <path d="M14 16.87A4 4 0 1 1 8 13v-2" />
    <path d="M16 12V8a5 5 0 0 0 5 5" />
  </svg>
);

export default TiktokIcon;

